import { useTranslation } from 'react-i18next';
import { FormSection } from '@zolteam/zol-admin-ui';
import { FormElements } from '@zolteam/zol-react-form';

/**
 * @typedef {object} BookingDemandsSectionProps
 * @property {import('@zolteam/zol-react-form/types').ConfigObject} formConfig
 * @property {{formName: string}} formInfo - The form information object
 */

/**
 * Demands section of the booking form
 * @param {BookingDemandsSectionProps} props
 * @returns {JSX.Element}
 */
function BookingDemandsSection({ formConfig, formInfo }) {
  const { t } = useTranslation();

  return (
    <FormSection label={t('bookingForm.section.demands')}>
      <FormElements
        translations={null}
        formConfig={formConfig}
        formTitle={formInfo.formName}
      />
    </FormSection>
  );
}

export default BookingDemandsSection;
